import React, { useCallback, useEffect, useState } from 'react';
import { IFNTheme, registerClass } from '@food/css-manager/build/dist';
import { parse } from 'url';
import { hash, setLocalAchievement } from '../utils/misc';
import { Modal } from '@food/ui/build/dist/src/Modal2';
import { useTranslation } from 'react-i18next';
import { isLogged } from '@food/auth/build/dist/logic/auth';
import { client } from './apps/NewsStand';
import { saveAchievementMutation } from '../utils/achievements';
import ReactGA from 'react-ga';

export interface PardotModalFormProps {
	url: string;
	onSubmit: () => void;
	children: (setModal: (open: boolean) => void) => JSX.Element;
}

const iframeClass = registerClass(
	(t: IFNTheme) => `
	width: 100%;
	min-height: 300px;
	display: block;
	padding: 0 ${t.ratios.l}rem;
`,
);

export const PardotModalForm: React.FC<PardotModalFormProps> = ({
	url,
	onSubmit,
	children,
}) => {
	const [iframeHeight, updateIframeHeight] = useState<number>(0);
	const { t } = useTranslation();
	const [modalOpen, setModalOpen] = useState<boolean>(false);
	const achievement = 'pardot:' + hash(url);

	const callback = useCallback((event) => {
		const parsedUrl = parse(url);
		if (event.origin === parsedUrl.protocol + '//' + parsedUrl.host) {
			if (event.data.submit) {
				setModalOpen(false);
				
				// imposto la voce nel localstorage, sempre utile per velocizzare i controlli
				setLocalAchievement(achievement);
				
				// se sono loggato vado anche a segnare l'achievement sul mio account
				if (isLogged()) {
					client.mutate({
						mutation: saveAchievementMutation,
						variables: { achievement },
					});
				}
				
				// siccome pardot viene usato per iscrizioni alle newsletter, segnalo l'evento ad analytics
				ReactGA.event({
					category: 'User',
					action: 'Subscription to newsletter',
				});
				
				// alla fine di tutto avvio la callback di successo
				onSubmit();
			} else if (typeof event.data === 'number') {
				updateIframeHeight(event.data);
			}
		}
	}, []);

	useEffect(() => {
		window.addEventListener('message', callback);
		return () => window.removeEventListener('message', callback);
	}, []);

	return (
		<>
			<Modal open={modalOpen} closeHandler={() => setModalOpen(false)}>
				{() => (
					<iframe
						title={t`typescript form frame`}
						className={iframeClass}
						style={{ height: iframeHeight + 'px' }}
						src={url}
					/>
				)}
			</Modal>
			{children(setModalOpen)}
		</>
	);
};
